if (!customElements.get('careers-values-scroller')) {
  class CareersValuesScroller extends HTMLElement {
    connectedCallback() {
      this.cards = this.querySelector('[data-careers-values-cards]');
      this.previous = this.querySelector('[data-careers-values-prev]');
      this.next = this.querySelector('[data-careers-values-next]');
      if (!this.cards || !this.previous || !this.next) return;

      this.isRtl = this.dataset.direction === 'rtl';
      this.updateArrows = () => {
        const { scrollLeft, scrollWidth, clientWidth } = this.cards;
        const maxScroll = scrollWidth - clientWidth;
        const overflows = maxScroll > 2;
        this.previous.hidden = !overflows || (this.isRtl ? scrollLeft >= -2 : scrollLeft <= 2);
        this.next.hidden = !overflows || (this.isRtl ? Math.abs(scrollLeft) >= maxScroll - 2 : scrollLeft >= maxScroll - 2);
      };
      this.scrollPrevious = () => this.scrollCards(-1);
      this.scrollNext = () => this.scrollCards(1);
      this.showArrows = (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => {
          this.classList.add('careers-values__scroller--hovered');
        }, 100);
      };
      this.hideArrows = (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.hoverTimer);
        this.classList.remove('careers-values__scroller--hovered');
      };

      this.cards.addEventListener('scroll', this.updateArrows, { passive: true });
      window.addEventListener('resize', this.updateArrows, { passive: true });
      this.previous.addEventListener('click', this.scrollPrevious);
      this.next.addEventListener('click', this.scrollNext);
      this.addEventListener('pointerenter', this.showArrows);
      this.addEventListener('pointerleave', this.hideArrows);
      this.updateArrows();
    }

    disconnectedCallback() {
      if (!this.cards) return;
      this.cards.removeEventListener('scroll', this.updateArrows);
      window.removeEventListener('resize', this.updateArrows);
      this.previous.removeEventListener('click', this.scrollPrevious);
      this.next.removeEventListener('click', this.scrollNext);
      this.removeEventListener('pointerenter', this.showArrows);
      this.removeEventListener('pointerleave', this.hideArrows);
      clearTimeout(this.hoverTimer);
    }

    scrollCards(direction) {
      const card = this.cards.querySelector('.careers-values__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.cards).gap) || 0;
      const delta = (this.isRtl ? -direction : direction) * (card.getBoundingClientRect().width + gap);
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.cards.scrollBy({ left: delta, behavior });
    }
  }

  customElements.define('careers-values-scroller', CareersValuesScroller);
}
